import * as React from 'react';
import * as _ from 'underscore'

import './Core.css';

import Browser from './Blocks/Browser'
import NavBar from './Blocks/NavBar'
import Timeline from './Blocks/Timeline'

import * as Split from 'split.js'

import DraggedToolCard from './Elements/DraggedToolCard'
import IDraggable from './IDraggable'
import {IDropZone} from './IDropZone'
import Modal from './Modal/Modal'
import ToolCard from './Elements/ToolCard';

import IModalOpenableProps from './Modal/IModalOpenableProps'
import TimelineCard from './Elements/TimelineCard';
import DraggedTimelineCard from './Elements/DraggedTimelineCard';

// tslint:disable-next-line:no-empty-interface
interface ICoreProps extends IModalOpenableProps {
    onSignOutRequested: () => void;
}

interface ICoreState {
    objectBeingDragged: IDraggable | null;
    objectDragData: { x: number, y: number, width: number, height: number }

    activeDropZones: Array<IDropZone<IDraggable>>;
}

class Core extends React.Component<ICoreProps, ICoreState> {
    private myBrowserInstance: Browser | null;
    private draggedCardRef: any;
    private modalRef: any;

    public constructor(props: ICoreProps & any) {
        super(props);

        this.myBrowserInstance = null;

        this.state = {
            objectBeingDragged: null,
            objectDragData: { x: 0, y: 0, width: 0, height: 0 },
            activeDropZones: new Array<IDropZone<IDraggable>>()
        };

        this.draggedCardRef = React.createRef();
        this.modalRef = React.createRef();
    }

    public render() {  
        return (
            <div
                className={"Core" + (this.state.objectBeingDragged ? " Core--drag-active" : "")}
                
                onMouseMove={this.mouseMoved}
                onMouseUp={this.mouseUpped}
                >

                <Modal ref={this.modalRef} />

                { this.getDraggedElement() }

                <NavBar onSearchTriggered={this.searchTriggered} onSignOutRequested={this.props.onSignOutRequested} />
                
                <div className="Workspace">
                    <Browser
                        onRef={this.browserSelfMounted}

                        dragActive={this.state.objectBeingDragged !== null}
                        onDragStart={this.dragStarted}

                        onDropZoneEnter={this.registerActiveDropZone}
                        onDropZoneLeave={this.unregisterActiveDropZone}
                        />

                    <Timeline
                        dragActive={this.state.objectBeingDragged !== null}
                        onDragStart={this.dragStarted}

                        onDropZoneEnter={this.registerActiveDropZone}
                        onDropZoneLeave={this.unregisterActiveDropZone}

                        openModal={this.props.openModal}
                        />
                </div>
            </div>
        );
    }

    public componentDidMount() {
        const oldSizesJSON: any = localStorage.getItem('workspace-split-sizes');
        let oldSizes: number[];
        if (oldSizesJSON) {
            oldSizes = JSON.parse(oldSizesJSON)
        } else {
            oldSizes = [75, 25]  // default sizes
        }

        const split = Split(['.Browser', '.Timeline'], {
            sizes: oldSizes,
            minSize: [200, 200],
            gutterSize: 3,
            onDrag: _.throttle(() => {
                if(this.myBrowserInstance) {
                    this.myBrowserInstance.resizeTriggered();
                }
            }, 350),
            onDragEnd: () => {
                localStorage.setItem('workspace-split-sizes', JSON.stringify(split.getSizes()));
            }
        });
    }
  
    public searchTriggered = (newSearchString: string) => {
        if(this.myBrowserInstance) {
            this.myBrowserInstance.searchTriggered(newSearchString);
        }
    }

    public browserSelfMounted = (browserInstance: Browser | null) => {
        this.myBrowserInstance = browserInstance;
    }

    private dragStarted = (event: React.MouseEvent, object: IDraggable) => {
        const boundingRect = object.getElement().getBoundingClientRect();
        this.setState({
            objectBeingDragged: object,
            objectDragData: { x: event.pageX - boundingRect.x, y: event.pageY - boundingRect.y, width: boundingRect.width, height: boundingRect.height },
        });

        if(object instanceof ToolCard) {
            /* do nothin' jon snow */
        } else if(object instanceof TimelineCard) {
            /* do nothin' jon snow */
        }
    };

    private mouseMoved = (event: React.MouseEvent) => {
        if(this.state.objectBeingDragged) {
            /* was thinking of moving some of the position handling to ToolCard itself, but I kind of want to keep it pure */

            const target: any = (this.draggedCardRef.current as IDraggable).getElement();

            const x: number = event.pageX - this.state.objectDragData.x;
            const y: number = event.pageY - this.state.objectDragData.y;

            target.style.zIndex = 2;
            target.style.webkitTransform =
                target.style.transform =
                    'translate(' + x + 'px, ' + y + 'px)';
            target.style.width = this.state.objectDragData.width + 'px';
            target.style.height = this.state.objectDragData.height + 'px';
        }
    };

    private mouseUpped = (event: React.MouseEvent) => {
        const cnt = this.state.activeDropZones.length;

        if(cnt > 0 && this.state.objectBeingDragged) { // the second check is here just to silence lint ;P
            this.state.activeDropZones[cnt-1].handleDrop(this.state.objectBeingDragged);
        }

        this.setState({ objectBeingDragged: null });
    };

    private getDraggedElement() {
        if(this.state.objectBeingDragged) {
            if(this.state.objectBeingDragged instanceof ToolCard) {
                return <DraggedToolCard
                        {...(this.state.objectBeingDragged as ToolCard).props} ref={this.draggedCardRef}
                        key={0}
                        />
                        ;
            } else if(this.state.objectBeingDragged instanceof TimelineCard) {
                return <DraggedTimelineCard
                        {...(this.state.objectBeingDragged as TimelineCard).props} ref={this.draggedCardRef}
                        key={0}
                        />
                        ;
            } else  {
                return <div />
            }
        } else {
            return <div />
        }
    }

    private registerActiveDropZone = (zone: IDropZone<IDraggable>) => {
        this.state.activeDropZones.push(zone);
    };

    private unregisterActiveDropZone = (zone: IDropZone<IDraggable>) => {
        const index = this.state.activeDropZones.indexOf(zone);
        this.state.activeDropZones.splice(index, 1);
    };
}

export default Core;



// WEBPACK FOOTER //
// ./src/App/Core.tsx